var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.151,
    height: 25,
    viewBox: "0 0 26.151 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1192",
    d: "M69.664 421.031a3.038 3.038 0 0 0 3.032 3.032h16.666v-2.229L72.6 421.8a.854.854 0 0 1-.559-.211.722.722 0 0 1-.251-.551.777.777 0 0 1 .811-.754h.008l16.756.032v-2.294L72.7 418a3.037 3.037 0 0 0-3.032 3.032z",
    transform: "translate(-69.664 -399.063)",
    style: {
      fill: "#a39d99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1193",
    d: "M389.71 77.021a7.727 7.727 0 0 0-.438-.016c-.089 0-.178 0-.267.008A5.755 5.755 0 0 0 389 88.507h.3c.138 0 .284 0 .413-.008a5.754 5.754 0 0 0 0-11.479zm.349 8.82a.758.758 0 0 1-1.516 0v-3.268a.758.758 0 1 1 1.516 0zm-.754-4.977a.756.756 0 1 1 .535-.225.758.758 0 0 1-.535.225z",
    transform: "translate(-368.901 -73.973)",
    style: {
      fill: "#a39d99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1194",
    d: "M82.793 20.786a7.244 7.244 0 0 1 6.566-7.223v-1.532l-16.667-.024a3.037 3.037 0 0 0-3.032 3.032v15.555a4.545 4.545 0 0 1 3.032-1.159h16.667v-1.418a7.24 7.24 0 0 1-6.566-7.231z",
    transform: "translate(-69.661 -12.007)",
    style: {
      fill: "#a39d99"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuide);
export default __webpack_public_path__ + "static/media/guide.783f3b4435892b7260d6abf70f3dd56c.svg";
export { ForwardRef as ReactComponent };